import { LoggingLevel } from "@multiweb/logging";
import { GlobalContext } from "Global/Base/GlobalContext";
import { ConsoleLogger } from "../Logging/ConsoleLogger";
import { IInitParams } from "./IInitParams";

/**
 * Načte konfigurační data ze standardního umístění
 * @param settingPath Cesta k souboru s konfigurací
 */
export async function loadAppConfiguration(settingPath: string = "./initParams.json"): Promise<Partial<IInitParams> | null> {
    let initParams: IInitParams | undefined = undefined;

    try {
        const response = await fetch(settingPath);
        initParams = await response.json();
    } catch (e1) {
        // pokud nebyla konfigurace nalezena ve složce s klientem, tak se zkouší najít ještě o úroveň výše (pro zachování zpětné kompatibility)
        try {
            const parentUrl = new URL(settingPath, new URL("..", location.href));
            const response = await fetch(parentUrl.href);
            initParams = await response.json();
        } catch (e2) {
            const logger = new ConsoleLogger();
            logger.log("AppConfiguration", LoggingLevel.error, "Unable to load configuration from initParams.", e2);
        }
    }

    return initParams || null;
}

GlobalContext.register("loadAppConfiguration", loadAppConfiguration);
